import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message, Select} from 'antd';
import { useBnsJiShuWenDangAddMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import MyEditor from '../../cpn/MyEditor';
import { techDocType } from '../developPublic';
function TechDocAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsJiShuWenDangAddMutation()
    const [info,setInfo] = useState({
        bjswd_content:'',
    });
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增技术文档'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bjswd_cid" : localStorage.getItem('eu_id'),
                                    "bjswd_cname" : localStorage.getItem('eu_name'),
                                    "bjswd_content" : info.bjswd_content,
                                    "bjswd_dept_id" : info.bjswd_dept_id,
                                    "bjswd_dept_name" : info.bjswd_dept_name,
                                    "bjswd_e_id" : localStorage.getItem('e_id'),
                                    "bjswd_name" : info.bjswd_name,
                                    "bjswd_type_id" : info.bjswd_type_id,
                                    "bjswd_type_name" : info.bjswd_type_name,                                    
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bjswd_dept_id:e,bjswd_dept_name:f}))
                            }}
                        />
                        <Form.Item
                            label='类型'
                            name='type'
                            wrapperCol={{span:10}}
                            required                            
                        >
                            <Select
                                options={techDocType}
                                onChange={(e,f) => {
                                    setInfo(prevState=>({...prevState,bjswd_type_id:e,bjswd_type_name:f.label}))
                                }}
                                showSearch
                                optionFilterProp="label"
                            />
                        </Form.Item>
                        <Form.Item name="name" label='标题' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjswd_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='正文' wrapperCol={{span:20}}>
                            <MyEditor 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjswd_content:e}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default TechDocAdd